export default "__VITE_ASSET__953c7640__"